import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Chart } from 'primereact/chart';

export const DialogChartMicrositePatients = ({
  chartDialogVisible,
  setChartDialogVisible,
  chartOptions,
  chartData,
  selectedData,
  currentAnalyteId,
  currentPatientNim
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const chartRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const currentAnalyte =
    selectedData?.find(
      (a) => a.id_analyte === currentAnalyteId && a.nim === currentPatientNim
    ) || {};

  const nombreExamen = currentAnalyte.name || '-';
  const resultado = currentAnalyte.result ?? '-';
  const referencia = currentAnalyte.range ?? '-';

  const downloadImage = () => {
    const chart = chartRef.current.getChart();

    const originalCanvas = chart.canvas;
    const scale = 3;

    const headerHeight = 90;

    const newCanvas = document.createElement('canvas');
    newCanvas.width = originalCanvas.width * scale;
    newCanvas.height = (originalCanvas.height + headerHeight) * scale;

    const ctx = newCanvas.getContext('2d');

    ctx.scale(scale, scale);

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, newCanvas.width, newCanvas.height);

    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    const centerX = originalCanvas.width / 2;

    const texto = `${nombreExamen}   |   Resultado: ${resultado}   |   Valores: ${referencia}`;

    ctx.font = 'bold 22px Arial';
    ctx.fillStyle = '#0d3b59';

    ctx.fillText(texto, centerX, 35);

    ctx.strokeStyle = '#dcdcdc';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(40, 60);
    ctx.lineTo(originalCanvas.width - 40, 60);
    ctx.stroke();

    ctx.drawImage(originalCanvas, 0, headerHeight);
    const url = newCanvas.toDataURL('image/png');

    const link = document.createElement('a');
    link.href = url;
    link.download = `GRAFICA_${nombreExamen}.png`;
    link.click();
  };
  
  return (
    <Dialog
      header="Gráfica del Analito"
      visible={chartDialogVisible}
      onHide={() => setChartDialogVisible(false)}
      headerStyle={{
        backgroundColor: '#0d3b59',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '1.2rem',
      }}
      modal
      closable
      dismissableMask={false}
      blockScroll
      className="responsive-dialog"
      style={{ width: isMobile ? '95%' : '80%', maxWidth: '1200px' }} 
    >
      <div
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          gap: isMobile ? '0.3rem' : '1rem',
          marginBottom: '1rem',
          fontWeight: 'bold',
          fontSize: isMobile ? '10px' : '13px',
        }}
      >
        <span>{nombreExamen}</span>
        <span>Resultado: {resultado}</span>
        <span>Valores de referencia: {referencia}</span>
      </div>

      <div
        style={{
          width: '100%',
          height: isMobile ? '300px' : '500px', 
        }}
      >
        <Chart
          ref={chartRef}
          type="line"
          data={chartData}
          options={{
            ...chartOptions,
            responsive: true,
            maintainAspectRatio: false,
          }}
          style={{ width: '100%', height: '100%' }}
        />
       
      </div>
    
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '-5px' }}>
        <button
          onClick={downloadImage}
          style={{
            backgroundColor: '#0d3b59',
            color: 'white',
            border: 'none',
            padding: '8px 12px',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Descargar gráfica
        </button>
      </div>
    </Dialog>
  );
};
